import { render, staticRenderFns } from "./StockItems.vue?vue&type=template&id=4c0bacb7&scoped=true"
import script from "./StockItems.vue?vue&type=script&lang=js"
export * from "./StockItems.vue?vue&type=script&lang=js"
import style0 from "./StockItems.vue?vue&type=style&index=0&id=4c0bacb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0bacb7",
  null
  
)

export default component.exports